"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _vue = _interopRequireDefault(require("vue"));

var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));

var _common = require("./common");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/** @module */
var UserState = /*#__PURE__*/function () {
  function UserState(user) {
    (0, _classCallCheck2.default)(this, UserState);
    this.nick = user.nick;
    this.host = user.host || '';
    this.username = user.username || '';
    this.realname = user.realname || '';
    this.modes = user.modes || '';
    this.away = user.away || '';
    this.colour = user.colour || '';
    this.account = user.account || '';
    this.buffers = Object.create(null);
    this.hasWhois = false;
    this.typingState = Object.create(null);
    this.avatar = user.avatar || {
      small: '',
      large: ''
    };
    this.ignore = false;

    _vue.default.observable(this); // Whois details are non-enumerable properties (vues $watch won't cover these properties)


    (0, _common.def)(this, 'actual_host', '', true);
    (0, _common.def)(this, 'helpop', '', true);
    (0, _common.def)(this, 'bot', '', true);
    (0, _common.def)(this, 'server', '', true);
    (0, _common.def)(this, 'server_info', '', true);
    (0, _common.def)(this, 'operator', '', true);
    (0, _common.def)(this, 'channels', '', true);
    (0, _common.def)(this, 'modes', '', true);
    (0, _common.def)(this, 'idle', '', true);
    (0, _common.def)(this, 'logon', '', true);
    (0, _common.def)(this, 'registered_nick', '', true);
    (0, _common.def)(this, 'secure', '', true);
    (0, _common.def)(this, 'special', '', true);
  }

  (0, _createClass2.default)(UserState, [{
    key: "getColour",
    value: function getColour() {
      if (!this.colour) {
        this.colour = TextFormatting.createNickColour(this.nick);
      } // default will use the themes default text colour


      return this.colour === 'default' ? '' : this.colour;
    }
  }, {
    key: "isAway",
    value: function isAway() {
      return !!this.away;
    }
  }, {
    key: "typingStatus",
    value: function typingStatus(_target, status) {
      var _this = this;

      var target = _target.toLowerCase();

      if (!status) {
        return this.typingState[target] || {
          status: ''
        };
      }

      var typing = this.typingState[target];

      if (!typing) {
        _vue.default.set(this.typingState, target, {
          started: 0,
          status: ''
        });

        typing = this.typingState[target];
      }

      if (typing.timeout) {
        clearTimeout(typing.timeout);
        typing.timeout = null;
      }

      if (status === 'done') {
        _vue.default.delete(this.typingState, target);

        return null;
      }

      typing.started = Date.now();
      typing.status = status; // Paused state gets a longer timeout as it's usually someone stopping typing
      // to think about their words

      var timeoutLen = status === 'paused' ? 30000 : 6000;
      typing.timeout = setTimeout(function () {
        return _this.typingStatus(target, 'done');
      }, timeoutLen);
      return typing;
    }
  }]);
  return UserState;
}();

exports.default = UserState;